import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const EXPORT_FILE = {
  URL: '/api/executesp/export/commonexcel',
  STORED_PROCEDURE_CODE: {
    IMEI_SN_ANALYSIS_DUPLICATION_SO_TOTAL: '60',
    IMEI_SN_ANALYSIS_DUPLICATION_SO_DETAIL: '61',
  },
  PARAM_CODE: {
    LOG_WEEK: '122',
    LOG_TYPE: '123',
    PAGE_SIZE: '4',
    OBJECT_CODE: '124',
    EXCEL_TYPE: '125'
  }
}

const IMEISNAnalysisDuplicationSOModel = {
  getIMEISNAnalysisDuplicationSO: (body) => modelBaseV2.post('/api/validationlog/imeiSnDuplicationSoList', { body }),
  imeiSNAnalysisDuplicationSOTotalExport: (body, fileName = `imei-sn-analysis-duplication-so-${moment().format('YYYYMMDD-HHmmss')}.xlsx`) => {
    const exportConfig = {
      storedProcedureCode: EXPORT_FILE.STORED_PROCEDURE_CODE.IMEI_SN_ANALYSIS_DUPLICATION_SO_TOTAL,
      params: [
        {
          code: EXPORT_FILE.PARAM_CODE.LOG_WEEK,
          value: body.logWeek,
        },
        {
          code: EXPORT_FILE.PARAM_CODE.LOG_TYPE,
          value: body.logType,
        },
        {
          code: EXPORT_FILE.PARAM_CODE.PAGE_SIZE,
          value: '-1',
        }
      ],
    };
    return modelBaseV2.postDownload(
      EXPORT_FILE.URL,
      {
        body: exportConfig,
      },
      fileName
    );
  },
  imeiSNAnalysisDuplicationSODetailExport: (body, fileName = 'template') => {
    const exportConfig = {
      storedProcedureCode: EXPORT_FILE.STORED_PROCEDURE_CODE.IMEI_SN_ANALYSIS_DUPLICATION_SO_DETAIL,
      params: [
        {
          code: EXPORT_FILE.PARAM_CODE.LOG_WEEK,
          value: body.logWeek,
        },
        {
          code: EXPORT_FILE.PARAM_CODE.LOG_TYPE,
          value: body.logType,
        },
        {
          code: EXPORT_FILE.PARAM_CODE.OBJECT_CODE,
          value: body.objectCode,
        },
        {
          code: EXPORT_FILE.PARAM_CODE.EXCEL_TYPE,
          value: body.excelType,
        }
      ],
    };
    return modelBaseV2.postDownload(
      EXPORT_FILE.URL,
      {
        body: exportConfig,
      },
      fileName
    );
  }
}
export default IMEISNAnalysisDuplicationSOModel